import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { VibeFeaturedQuote as VibeFeaturedQuoteType } from "redmond";
import styles from "./styles.module.scss";

export interface VibeFeaturedQuoteProps {
  featuredQuote: VibeFeaturedQuoteType;
  isMobile: boolean;
}

export const VibeFeaturedQuote: React.FC<VibeFeaturedQuoteProps> = ({
  featuredQuote,
  isMobile,
}) => {
  const byline = [featuredQuote.dateSubmitted, featuredQuote.customer]
    .filter(Boolean)
    .join(" // ");

  return (
    <Box className={clsx(styles.root, { [styles.mobile]: isMobile })}>
      <Typography className={styles.quote} component="p" variant="h3">
        “{featuredQuote.quote}”
      </Typography>
      <Typography className={styles.byline} variant="overline">
        {byline}
      </Typography>
    </Box>
  );
};
